import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'urql';
import App from './App.jsx';
import { ThemeProvider } from './theme/ThemeContext.jsx';
import { AuthProvider } from './state/auth/AuthContext.jsx';
import { UIProvider } from './context/UIContext.jsx';
import { gqlClient } from './graphql/client.js';
import { apolloClient } from './apollo/client.js';
import './styles/global.css';
import './theme/tailwind.css';
import './styles/base.css';
import './styles/theme.css';
import '@coreui/coreui/dist/css/coreui.min.css';

const shouldBootstrapQaInstrumentation =
  import.meta.env.DEV &&
  (
    import.meta.env.VITE_ENABLE_OPERATOR_COMPACT_QA === '1' ||
    import.meta.env.VITE_ENABLE_QA_SESSION_INJECTION === '1'
  );

if (shouldBootstrapQaInstrumentation) {
  // QA compacta e inyeccion de sesion: solo DEV y con flags explicitos.
  import('./utils/operatorCompactQa.js').then(({ bootstrapOperatorCompactQaSession }) => {
    bootstrapOperatorCompactQaSession();
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <UIProvider>
            <ApolloProvider client={apolloClient}>
              <Provider value={gqlClient}>
                <App />
              </Provider>
            </ApolloProvider>
          </UIProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
